<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.UNAPPEND
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <b-field label="Justificativa" customClass="has-text-color-7">
          <b-input
            v-model="message"
            maxlength="200"
            type="textarea"
            :placeholder="General.PLACEHOLDER.UNAPPEND_JUSTIFICATION"
          ></b-input
        ></b-field>

        <div class="list-container spacing-mb-30 is-size-7">
          <table
            class="table has-text-black"
            :title="General.TEXTS.PROCESS_LIST"
            :aria-describedby="General.TEXTS.PROCESS_LIST"
          >
            <thead>
              <tr>
                <th class="has-text-color-8 is-size-7">{{ General.NUP }}</th>
                <th class="has-text-color-8 is-size-7">
                  {{ General.SUBJECT }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="process in [appendedProcess]" :key="process.id">
                <td class="has-text-color-8">
                  {{ applyMaskNUP(process.nup) }}
                </td>
                <td class="has-text-color-8 has-text-weight-semibold">
                  {{ process.subject }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <div class="buttons">
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          @click="confirmAction"
        >
          {{ General.UNAPPEND.toUpperCase() }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          class="is-outlined"
          @click="$emit('close')"
        >
          {{ General.CANCEL.toUpperCase() }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";
import { NUP, applyMask } from "@/utils/protocols";

export default {
  name: "ModalUnappendProcess",

  props: {
    appendedProcess: {
      type: Object,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      message: ""
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },

  methods: {
    ...mapActions({ setProcessUnappended: "setProcessUnappended" }),

    async confirmAction() {
      if (this.message.length) {
        this.isLoading = true;
        const processDetachJoin = {
          process_join_id: this.appendedProcess.id,
          justification: this.message
        };

        const status = await this.setProcessUnappended({
          processId: this.appendedProcess.process_join,
          processDetachJoin
        });
        this.isLoading = false;
        if (status) {
          this.close();
          this.onClose();
        }
      } else {
        this.snackToast.open({
          message: this.General.TEXTS.UNAPPEND_JUSTIFICATION,
          type: "is-danger",
          duration: 8000
        });
      }
    },

    close() {
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 20px;
}
</style>
